import React from 'react'

class RepaymentFrequency extends React.Component {
  render() {
    const { onClick } = this.props
    const { isDreamSpace } = this.props;
    const className = isDreamSpace ? 'dreamspace' : '';
    return(
      <div className='form-group'>
        <label>How frequently are you repaying?</label>
          <div className={`
              btn-group
              btn-group-radio-tabs
              btn-group-toggle 
              btn-group-sm 
              btn-group-expand 
              ${className} 
              d-flex
            `} data-toggle='buttons'>
          <label id='monthly' className={`btn onboarding-form active ${className}`} onClick={() => onClick('monthly')}>
            <input id="monthly" name="frequency" type="radio" />
            <div>Monthly</div>
          </label>
          <label id='fortnightly' className={`btn onboarding-form ${className}`} onClick={() => onClick('fortnightly')}>
            <input id="fortnightly" name="frequency" type="radio" />
            <div>Fortnightly</div>
          </label>
          <label id='weekly' className={`btn onboarding-form ${className}`} onClick={() => onClick('weekly')}>
            <input id="weekly" name="frequency" type="radio" />
            <div>Weekly</div>
          </label>
        </div>
      </div>
    )
  }
}

export default RepaymentFrequency;
